// extracted by mini-css-extract-plugin
export default {"container":"DiceBoard_container__VZh5Q","content":"DiceBoard_content__s5lwN","board":"DiceBoard_board__eVrGJ","arrow":"DiceBoard_arrow__SRQnK","pulse":"DiceBoard_pulse__8yi+Q"};